import { postToController, logErrorToDatabase } from './apiActions';

export const validatePayment = (reference: string) => {
    return async (dispatch) => {
        let result: any = null;
        await postToController(dispatch, 'Payment/ValidatePayment',
            JSON.stringify({
                reference,
            }))
            .then(async response => {
                result = response;
            })
            .catch(err => logErrorToDatabase("PaymentActions > ValidatePayment Error: " + err));
        return result;
    }
}
